export const MODULE_NAME = 'PatientAssignments'
export const MMN = 'Meritage Medical Network'
export const FCMG = 'First Choice Medical Group'
